import { Box, Link, Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import poweredByBggLogo from '../assets/powered-by-bgg.png';

const bggUrl = 'https://boardgamegeek.com';

const BGGAttribution = ({ mode = 'inline', sx }) => {
  const { t } = useTranslation();
  const isFooter = mode === 'footer';

  return (
    <Paper
      component={isFooter ? 'footer' : 'aside'}
      aria-label="BoardGameGeek attribution"
      variant="outlined"
      sx={{
        display: 'inline-flex',
        width: isFooter ? '100%' : 'auto',
        maxWidth: '100%',
        p: isFooter ? { xs: 1.5, sm: 2 } : 1,
        borderStyle: isFooter ? 'solid' : 'dashed',
        bgcolor: isFooter
          ? 'rgba(255, 250, 240, 0.72)'
          : 'rgba(255, 250, 240, 0.88)',
        boxShadow: 'none',
        ...sx,
      }}
    >
      <Stack
        direction={{ xs: isFooter ? 'column' : 'row', sm: 'row' }}
        spacing={1.25}
        alignItems={{ xs: isFooter ? 'flex-start' : 'center', sm: 'center' }}
        justifyContent={isFooter ? 'space-between' : 'flex-start'}
        sx={{ width: '100%' }}
      >
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            lineHeight: 1.35,
            maxWidth: isFooter ? 560 : 360,
          }}
        >
          {t('bgg.attribution.copy')}
        </Typography>

        <Link
          href={bggUrl}
          target="_blank"
          rel="noreferrer"
          aria-label={t('bgg.attribution.linkLabel')}
          sx={{
            display: 'inline-flex',
            flex: '0 0 auto',
            borderRadius: 1,
            outlineOffset: 4,
          }}
        >
          <Box
            component="img"
            src={poweredByBggLogo}
            alt="Powered by BGG"
            sx={{
              display: 'block',
              width: isFooter
                ? { xs: 132, sm: 154 }
                : { xs: 118, sm: 132 },
              maxWidth: '100%',
              height: 'auto',
            }}
          />
        </Link>
      </Stack>
    </Paper>
  );
};

export default BGGAttribution;
